import { z } from 'zod';

export const VALIDATE_SCHEMA = z.object({
  email: z.string().email({ message: 'Некорректные данные' }),
});
